import { useEffect, useState } from "react";
import {configData} from "../../config";

export default function CurrencyConverter({ price }) {

    const [selectedCountry, setSelectedCountry] = useState("GB");
    const [countrieslist, setCountriesList] = useState({});
    const [convertedText, setConvertedText] = useState("");
    const app_url = configData.APP_URL; 
    useEffect(() => {
            Promise.all([
              retrieveCountriesList(),
             getCurrencyCalculation("GB"),
            ])
            .then(() => {
         
            
            })
         
        },[]);
async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }
  const getCurrencyCalculation = async (country) => {
    try {
     
      const postData = {
           country: country,
           price:price
          };
          try {
            const response = await fetch(app_url + 'coursepages/getcountryprice', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setConvertedText(data.data.text);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
  const handleCountryChange = async (e) => {
     setSelectedCountry(e.target.value);
    const country = e.target.value;
    try {
     
      const postData = {
           country: country,
           price:price
          };
          try {
            const response = await fetch(app_url + 'coursepages/getcountryprice', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setConvertedText(data.data.text);
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
    return (
        <div className="currency-converter">
            <span className="pay_heading">PRICE IN </span>

            <select id= "currency_select_0"
                value={selectedCountry}
                onChange={handleCountryChange}
            >
                <optgroup label="Top Countries">
                <option value="US">United States</option>
                <option value="GB">United Kingdom</option>
                <option value="IN">India</option>
                <option value="AU">Australia</option>
                <option value="CA">Canada</option></optgroup>
                <optgroup label="All Countries">
                 {Array.isArray(countrieslist) &&countrieslist.map((country) => (
        <option key={country.value} value={country.value}>
            {country.label}
        </option>
    ))}</optgroup>
            </select>
                <div
    className="payment_description"
    style={{ marginTop: 15, marginLeft: 0 }}
    dangerouslySetInnerHTML={{ __html: convertedText }}
></div>
        </div>
    );
}